import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { ToastService } from '../../services/toast.service';

@Directive({
  selector: '[appAmountFormat]',
  standalone: true
})
export class AmountFormatDirective {
  @Input() maxDecimals = 2;
  @Input() invalidMessage = 'Invalid amount format';

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private toast: ToastService
  ) {}

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    const blockedKeys = ['e', 'E', '+', '-'];
    if (blockedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const sanitized = this.sanitize(input.value || '');
    if (input.value !== sanitized) {
      input.value = sanitized;
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();

    const input = this.el.nativeElement;
    const pasted = (event.clipboardData?.getData('text') || '').trim();
    const sanitized = this.sanitize(pasted);
    const isInvalid = !pasted || sanitized !== pasted;

    input.value = sanitized;
    input.dispatchEvent(new Event('input', { bubbles: true }));

    if (isInvalid) {
      this.toast.error(this.invalidMessage);
    }
  }

  private sanitize(value: string): string {
    let sanitized = value.replace(/[^0-9.]/g, '');

    const firstDot = sanitized.indexOf('.');
    if (firstDot !== -1) {
      sanitized =
        sanitized.slice(0, firstDot + 1) +
        sanitized.slice(firstDot + 1).replace(/\./g, '');
    }

    const parts = sanitized.split('.');
    if (parts.length > 1) {
      parts[1] = parts[1].slice(0, this.maxDecimals);
      sanitized = `${parts[0]}.${parts[1]}`;
    }

    return sanitized;
  }
}

